module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Desktop_18.ee1a2fc9.jpg";